import type { ReactNode } from "react";

interface PageHeroProps {
  eyebrow: string;
  title: ReactNode;
  subtitle?: ReactNode;
  size?: "sm" | "md";
}

/**
 * Editorial page header — eyebrow + serif title + body. Replaces the
 * old dark gradient hero; on the parchment palette the headline carries
 * the section on its own.
 */
export function PageHero({ eyebrow, title, subtitle, size = "md" }: PageHeroProps) {
  const padding = size === "sm" ? "py-14 sm:py-16" : "py-16 sm:py-20";
  const titleSize =
    size === "sm"
      ? "text-[clamp(1.75rem,4vw,2.5rem)]"
      : "text-[clamp(2rem,5vw,3rem)]";
  return (
    <section className={`border-b border-line bg-parchment ${padding}`}>
      <div className="mx-auto w-full max-w-[1180px] px-6 sm:px-12">
        <span className="eyebrow">{eyebrow}</span>
        <h1
          className={`mt-7 max-w-[760px] font-serif font-normal leading-[1.08] tracking-[-0.02em] text-ink ${titleSize}`}
        >
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 max-w-[640px] text-[16px] leading-[1.65] text-ink-soft sm:text-[17px]">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
